import { render } from "./HrApproveOvertimePage.vue?vue&type=template&id=30f6c00e&scoped=true"
import script from "./HrApproveOvertimePage.vue?vue&type=script&lang=js"
export * from "./HrApproveOvertimePage.vue?vue&type=script&lang=js"

import "./HrApproveOvertimePage.vue?vue&type=style&index=0&id=30f6c00e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f6c00e"]])

export default __exports__